export default "__VITE_ASSET__6Qm7sifS__"